import { GlobalStore } from "@roc/feature-app-core";
import { ReferralFeeInternalService } from "../services/referralFeeService";
import { ReferralFeeStore } from "./referralFeeStore";
import { makeObservable, override, flow } from "mobx";
import { GENERIC_ERROR_MESSAGE } from "@roc/feature-utils";

export class ReferralFeeInternalStore extends ReferralFeeStore {
  private referralFeeService: ReferralFeeInternalService;

  constructor(globalStore: GlobalStore) {
    super(globalStore);
    this.referralFeeService = new ReferralFeeInternalService();
    makeObservable(this, {
      referralLink: override,
      getReferralFeeLink: flow,
      getBankInformation: flow,
      approveBankInformation: flow
    })
  }

  *getReferralFeeLink(loanId: string) {
    this.referralFeeService.getReferralFeeLink(loanId).then(response => {
      this.referralLink = response.data.data;
    }).catch(error => this.globalStore.notificationStore.showErrorNotification({
      message: 'Error getting referral fee authorization link'
    }));
  }

  *getBankInformation(referrerId: string, loanId?: string) {
    this.referralFeeService.getBankInfo(referrerId).then(response => {
      this.bankInfo = response.data
    });
  }

  *approveBankInformation(referrerId: string, callback: () => void) {
    this.referralFeeService.approveBankInformation(referrerId).then(response => {
      callback();
    }).catch(error => this.globalStore.notificationStore.showErrorNotification({ message: GENERIC_ERROR_MESSAGE }));
  }
}